/**
 * Where each backend service is reached from the browser.
 *
 * Each service serves `/v2/...` on its own port. The browser never sees the
 * ports: it asks this origin for `/auth/v2/...`, `/order/v2/...`,
 * `/billing/v2/...`, `/notify/v2/...`, `/realtime/v2/...`, `/content/v2/...`, `/audit/v2/...`,
 * and whatever sits
 * in front (Vite's proxy in development, the gateway in production) strips
 * the prefix and passes the rest on.
 *
 * No page of the app may live under one of these prefixes followed by a
 * slash: `/orders` is a page, `/order/...` is hg-order.
 */
export const SERVICE_PREFIXES = {
  auth: "/auth",
  order: "/order",
  billing: "/billing",
  notify: "/notify",
  realtime: "/realtime",
  content: "/content",
  audit: "/audit",
} as const;

export type Service = keyof typeof SERVICE_PREFIXES;

const origin = (import.meta.env.VITE_API_ORIGIN ?? "").replace(/\/+$/, "");

export function serviceUrl(service: Service): string {
  return `${origin}${SERVICE_PREFIXES[service]}`;
}
